import React from 'react';

const CloseModalIcon: React.FC = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M6.35341 17.4751L16.6882 7.1366M6.35156 7.13844L16.69 17.4732" stroke="black" />
    </svg>
  );
};

export default CloseModalIcon;
